module.exports = __webpack_public_path__ + "img/icon62.9c471156.png";